var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language"},[_c('Select',{attrs:{"value":_vm.value},on:{"input":_vm.select}},_vm._l((_vm.options),function(item){return _c('Option',{key:item.code,attrs:{"label":item.name,"value":item.code}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }